import { oauthTokenSelector } from 'selectors/app'
import { SKIP_NEXT_ORDER_REQUEST } from 'ducks/integrations/recharge/types'
import { doSdkRequest } from 'ducks/requests/operations'
import { doLinkResource } from 'actions/userIntegrations'
import { getRechargeMerchantUrl } from 'ducks/integrations/recharge/utils'

import selectIntegrationForId from 'ducks/integrations/selectors/selectIntegrationForId'
import * as api from '../api'

const doSkipNextOrder = ({
  customerId,
  subscriptionId,
  chargeId,
  integrationId,
}) => {
  return doSdkRequest(
    SKIP_NEXT_ORDER_REQUEST,
    async ({ getState, dispatch }) => {
      let state = getState()
      const token = oauthTokenSelector(state)

      const data = {
        purchase_item_ids: [subscriptionId],
      }
      const { response } = await api.skipCharge(
        token,
        integrationId,
        chargeId,
        JSON.stringify(data)
      )

      state = getState()

      const integration = selectIntegrationForId(state, integrationId)

      const subscriptionUrl = getRechargeMerchantUrl(
        integration.fullStoreDomain,
        `merchant/subscriptions/${subscriptionId}/details`
      )

      await dispatch(
        doLinkResource({
          id: `${customerId}-${subscriptionId}-order-skipped`,
          provider: 'recharge',
          title: `${subscriptionId}-order-skipped`,
          url: subscriptionUrl,
        })
      )

      return response
    },
    {
      customerId,
      subscriptionId,
      chargeId,
      integrationId,
    },
    {
      moduleOptions: {
        toasts: {
          enabled: true,
          started: {
            enabled: false,
          },
          success: {
            enabled: true,
            content: 'Next order skipped successfully!',
          },
          failed: {
            content: 'Something went wrong.',
          },
        },
      },
    }
  )
}

export default doSkipNextOrder
